import React from 'react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { TomoItem } from './TomoItem';
import { tomos } from '../data/tomos';
export function TomosSection() {
  return <section id="tomos" className="bg-mp-dark py-16 md:py-24 scroll-mt-16" data-id="element-288" data-mp="1p4lij4zavhpu">
      <Container data-id="element-289" data-mp="1u36j55igs3et">
        <div className="max-w-[700px]" data-id="element-290" data-mp="1u1lmnaclaaeb">
          <SectionTag tone="lime" data-id="element-291" data-mp="1u4rbqpl7xca1">Lo que recibes hoy</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-292" data-mp="xdpg6yav8vgt">
            Todo lo que necesitas, en un solo sistema.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-mp-gray" data-id="element-293" data-mp="16cj7c95fgtmz">
            5 tomos + herramientas prácticas para organizar, progresar y profesionalizar tus clases desde el primer
            día.
          </p>
        </div>

        <p className="mt-10 font-heading text-xs uppercase tracking-[0.2em] text-mp-electric" data-id="element-294" data-mp="2hrfzhrwwryyk">Los 5 tomos</p>
        <div className="mt-4 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5" data-id="element-295" data-mp="2mpr9c2n7e9gs">
          {tomos.map((tomo, index) => <TomoItem key={tomo.number} tomo={tomo} index={index} data-id="element-296" data-mp="2qlw4bd6evu8r" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}